import { useQuery } from '@tanstack/react-query';
import useGlynt from '../hooks/useGlynt';

const useMatById = (orgId: string | undefined, matId: string | number | undefined) => {
  const glynt = useGlynt();
  const enabled = Boolean(orgId && matId);

  return useQuery({
    queryKey: ['mat', 'by-id', orgId, matId],

    queryFn: async () => {
      const g = await glynt;
      return g.mat.retrieve(orgId as string, String(matId));
    },

    enabled
  });
};

export default useMatById;
